import React from "react";
import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import { useHistory } from "react-router-dom";

interface ShopifyTokenExpirationAlertProps {
  showProgressBar?: boolean;
}

const ShopifyTokenExpirationAlert: React.FC<ShopifyTokenExpirationAlertProps> = () => {
  const history = useHistory();
  
  const navigateToStoreDetails = () => {
    history.push("/app/settings/store-connections");
  };

  return (
    <VuiBox width="100%" mb={0} mt={0}>
      <Card sx={{
        borderLeft: '4px solid #ff4d4f',
        boxShadow: '0 4px 20px 0 rgba(0,0,0,0.14), 0 7px 10px -5px rgba(0,0,0,0.4)'
      }}>
        <VuiBox p={0}>
          <VuiBox display="flex" justifyContent="space-between" alignItems="center">
            <VuiBox>
              <VuiTypography variant="button" color="error" fontWeight="bold">
                Shopify Access Token Invalid
              </VuiTypography>
              <VuiTypography variant="caption" color="text" fontWeight="regular" display="block" mt={0.5}>
                Your Shopify integration features may not work properly. Please reconnect your store.
              </VuiTypography>
            </VuiBox>
            {/* @ts-ignore */}
            <VuiButton 
              variant="contained" 
              color="error"
              onClick={navigateToStoreDetails}
              size="small"
            >
              Reconnect Store
            </VuiButton>
          </VuiBox>
        </VuiBox>
      </Card>
    </VuiBox>
  );
};

export default ShopifyTokenExpirationAlert; 